package crashreporting

import org.koin.core.module.Module
import org.koin.dsl.module

fun crashreportingModule(config: CrashReporterConfig): Module = module {
    single { config }
    single<CrashReporter> { createCrashReporter(get()) }
}
